export const QUICK_ENTRY_SELECTION_KEYS = {
  candidate: 'candidate',
  jobOrder: 'jobOrder'
};
